"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _Strip = require("./Strip.style");

var Strip = function Strip(_ref) {
  var text = _ref.text,
      variant = _ref.variant,
      link = _ref.link;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      colors = _ref2.colors,
      strip = _ref2.strip;

  var linkColor = variant === 'primary' ? colors[strip.anchorFontColor] : colors[strip.anchorFontColorSecondary];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, text && /*#__PURE__*/_react.default.createElement(_Strip.StripContainer, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_Strip.StripText, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    html: text
  })), link && /*#__PURE__*/_react.default.createElement(_Strip.StripLink, {
    to: link.url,
    color: linkColor
  }, link.label)));
};

Strip.propTypes = {
  link: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }),
  text: _propTypes.default.string,
  variant: _propTypes.default.oneOf(['primary', 'secondary'])
};
Strip.defaultProps = {
  link: null,
  text: '',
  variant: 'primary'
};
var _default = Strip;
exports.default = _default;